import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-category-page-one',
  templateUrl: './category-page-one.component.html',
  styleUrls: ['./category-page-one.component.scss']
})
export class CategoryPageOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
